import { faAward, faMoneyBill, faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons'
import { REWARDS_ENABLED } from './helpers/rewardsEnabled'

export const homeRoutes = {
  name: 'Inicio',
  to: '/root',
  exact: true,
  iconsrc: 'Icono Inicio 2.png'
}

export const condominiumRoutes = {
  to: '/root/condominiums',
  name: 'Condominios',
  iconsrc: 'Icono Condominio 2.png'
}

export const indicatorsRoutes = {
  to: '/root/indicators',
  name: 'Indicadores',
  iconsrc: 'Icono Finanzas 2.png'
}

export const payMethodsRoutes = {
  to: '/root/paymethods',
  name: 'Métodos de pago',
  iconsrc: 'Icono Bancos 2.png'
}

export const supportRoutes = {
  to: '/root/support',
  name: 'Soporte',
  iconsrc: 'Icono Soporte 2.png'
}

export const leadsRoutes = {
  to: '/root/lead',
  name: 'Leads',
  iconsrc: 'Icono Condominio 2.png'
}

export const accountDeletionRoutes = {
  to: '/root/account-deletion',
  name: 'Eliminación de cuentas',
  iconsrc: 'Icono Centro de quejas 2.png'
}

// HO-TASK-289: panel del programa Homelan Rewards (reporte, configuración y
// aliados). Mismo ícono de FontAwesome que usan propietario y administrador.
export const rewardsRoutes = {
  to: '/root/rewards',
  name: 'Homelan Rewards',
  icon: faAward
}

export const configRoutes = {
  to: '/root/config',
  name: 'Configuración',
  iconsrc: 'Icono Configuracion 2.png'
}

/* export const exchangeRoutes = {
  to: '/root/exchange',
  name: 'Tasas de cambio',
  iconsrc: 'Icono Finanzas 2.png'
} */

const rootRoutes = [
  homeRoutes,
  condominiumRoutes,
  indicatorsRoutes,
  payMethodsRoutes,
/*   exchangeRoutes, */
  supportRoutes,
  leadsRoutes,
  accountDeletionRoutes,
  ...(REWARDS_ENABLED ? [rewardsRoutes] : []),
  configRoutes
]

export default rootRoutes
